import { SITE } from "@/data/site";
import { getServicePath } from "@/data/services";

export function LocalBusinessJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `${SITE.url}/#organization`,
    name: SITE.name,
    image: SITE.logo,
    url: SITE.url,
    telephone: SITE.phone,
    email: SITE.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: SITE.address.street,
      addressLocality: "Beograd",
      addressRegion: "Rakovica",
      postalCode: SITE.address.postalCode,
      addressCountry: "RS",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 44.7469,
      longitude: 20.4489,
    },
    areaServed: [
      { "@type": "City", name: "Beograd" },
      { "@type": "AdministrativeArea", name: "Rakovica" },
    ],
    description:
      "TOP WASH DOO — vodeća B2B perionica u Beogradu za profesionalno pranje tekstila. Restorani, hoteli, kafići, spa centri. Industrijska hemija i omekšivači premium klase.",
    priceRange: "$$",
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "20:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Saturday",
        opens: "09:00",
        closes: "15:00",
      },
    ],
    sameAs: [SITE.url],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function BreadcrumbJsonLd({ service }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Početna",
        item: SITE.url,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Usluge",
        item: `${SITE.url}/#services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: service.breadcrumb || service.shortTitle,
        item: `${SITE.url}${getServicePath(service.slug)}`,
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function ServiceJsonLd({ service }) {
  const url = `${SITE.url}${getServicePath(service.slug)}`;
  const data = {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${url}#service`,
    name: service.title,
    description: service.seoIntro || service.metaDescription,
    serviceType: service.title,
    category: "Profesionalno pranje tekstila za ugostiteljstvo",
    provider: {
      "@type": "LocalBusiness",
      "@id": `${SITE.url}/#organization`,
      name: SITE.name,
      url: SITE.url,
      telephone: SITE.phone,
      address: {
        "@type": "PostalAddress",
        addressLocality: "Beograd",
        addressCountry: "RS",
      },
    },
    areaServed: {
      "@type": "City",
      name: "Beograd",
    },
    url,
    image: service.image,
    offers: {
      "@type": "Offer",
      priceCurrency: "RSD",
      availability: "https://schema.org/InStock",
      url: `${SITE.url}/#contact`,
      description: "Besplatna procena i personalizovana B2B ponuda",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebPageJsonLd({ service }) {
  const url = `${SITE.url}${getServicePath(service.slug)}`;
  const data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": url,
    url,
    name: service.metaTitle,
    description: service.metaDescription,
    inLanguage: "sr-RS",
    isPartOf: { "@id": SITE.url },
    about: { "@id": `${url}#service` },
    primaryImageOfPage: service.image,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function FaqJsonLd({ faq }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: {
        "@type": "Answer",
        text: a,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
